var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.334,
    height: 7.307,
    viewBox: "0 0 13.334 7.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38124",
    "data-name": "Path 38124",
    d: "M144.4,21.889a1.6,1.6,0,0,0-2.095,0L138.167,25.6l-4.138-3.711a1.6,1.6,0,0,0-2.095,0,1.233,1.233,0,0,0,0,1.879l5.185,4.65a1.6,1.6,0,0,0,2.095,0l5.185-4.65A1.233,1.233,0,0,0,144.4,21.889Z",
    transform: "translate(-131.5 -21.5)",
    fill: "#2148ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.124c326761b32af40192801d4f82f6c1.svg";
export { ForwardRef as ReactComponent };